export const generateDeviceUUIDAndCheckMatch = async (
  customerId: string,
  setDeviceUuid: (uuid: string) => void,
): Promise<boolean> => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const { DeviceUUID } = await import('device-uuid');
    const du = new DeviceUUID().parse();
    const dua = [
      du.language,
      du.platform,
      du.os,
      du.cpuCores,
      du.isAuthoritative,
      du.silkAccelerated,
      du.isKindleFire,
      du.isDesktop,
      du.isMobile,
      du.isTablet,
      du.isWindows,
      du.isLinux,
      du.isLinux64,
      du.isMac,
      du.isiPad,
      du.isiPhone,
      du.isiPod,
      du.isSmartTV,
      du.pixelDepth,
      du.isTouchScreen,
      customerId,
    ];

    const uuid = du.hashMD5(dua.join(':'));
    // console.log('Generated UUID:', uuid);

    setDeviceUuid(uuid);

    const lastLoginDeviceId = localStorage.getItem('deviceId');
    // console.log('Last login deviceId:', lastLoginDeviceId);
    // console.log('Current deviceUuid:', uuid);

    if (!lastLoginDeviceId || lastLoginDeviceId == '') {
      return false;
    }

    const matchResult = lastLoginDeviceId.toLowerCase() === uuid.toLowerCase();
    // console.log('matchResult::::', matchResult);
    return matchResult;
  }

  return false;
};
